import { Entry } from '../Entry'

export function Entry20230215() {
  return (
    <Entry title="15/02/2023 - v3.3.4">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13665/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
